const ORDER_EDIT_PATH_PATTERN = /^\/orders\/[^/]+$/;

export const shouldHideIntercomLauncher = (pathname: string) =>
  pathname === '/new-order' || ORDER_EDIT_PATH_PATTERN.test(pathname);
